import { useKitbagAuth } from '@statsbomb/kitbag-auth';
import { useAtomValue } from 'jotai';
import { useLocation } from 'react-router-dom';
import { loadableUserDetailsAtom } from '@/atoms/queries/user';
import { canUserSeeAlphaTestingFeatures } from '@/utils/user';
import { initialiseSnowplow, initialSentrySetup } from '../analytics';

export const useTracking = () => {
  const { user: auth0User } = useKitbagAuth();
  const { pathname } = useLocation();
  const section = pathname.split('/')[2];

  if (auth0User?.sub) {
    initialSentrySetup(auth0User.sub, auth0User.email);
  }

  const userDetails = useAtomValue(loadableUserDetailsAtom);

  if (userDetails?.state !== 'hasData' || !auth0User?.sub) return;

  const details = userDetails.data.data;
  const { user, entity } = details;

  initialiseSnowplow(
    user.hudl_user_id,
    entity.entity_id,
    entity.name,
    canUserSeeAlphaTestingFeatures(userDetails.data.data),
    pathname,
    section,
  );
};
